export default __webpack_public_path__ + "static/media/departments.92236921.svg";